import { render } from "./ScreeningsView.vue?vue&type=template&id=929b5ea2"
const script = {}

import "./ScreeningsView.vue?vue&type=style&index=0&id=929b5ea2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__